<script setup lang="ts">
defineSlots<{ default: () => void }>();
</script>

<template>
  <LayoutContainer>
    <template #page>
      <Navbar />
      <slot />
      <Footer />
    </template>
  </LayoutContainer>
</template>
